import React, { useEffect, useState } from 'react';
import { ArrowLeftIcon, MenuIcon, SaveIcon, SendIcon, SendTicketIcon, TicketBackIcon, TicketStatusIcon, TicketStatusSaveIcon } from '../Icons/icons.component';
// import { sendTicketReply, sendTicketStatusUpdate } from '../../actions/tickets-action';
import { useSelector } from 'react-redux';
import { COOKIE } from '../../constants/app-constant';
import { getCookie } from '../../utility/cookieProvider';
import Loader from './Loader';
import { sendTicketReply, sendTicketStatusUpdate } from '../../actions/tickets-action';
import ConceptLogo from "../../assets/images/conceptbiu-logo.png";

const Ticket = ({
  setShowList,
  ticketData,
  messageData = [],
  msgUserList = [],
  isMsgLoading
}) => {
  const masterUser =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.masterUser
    ) || {};
  const userId = getCookie(COOKIE.CONCEPT_USER_ID);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [status, setStatus] = useState(0);
  const [notifyMaster, setNotifyMaster] = useState(1);

  useEffect(() => {
    setMessages(messageData)
  },[messageData])

  useEffect(() => {
    console.log(ticketData)
    setStatus(ticketData.status?ticketData.status:0)
  },[ticketData])

  const sendMessage = async (text) => {
    if (!text.trim()) return;
    let tObj = {
      header_id : ticketData.header_id,
      user_id:ticketData.user_id,
      message:text,
      created_by:userId,
      notify_master : notifyMaster,
      master_id : ticketData.master_id,
      client_id : ticketData.client_id
    }
    let resData = await sendTicketReply(tObj)
    if(resData){
      const newMessage = tObj;
      setMessages([...messages, newMessage]);
    }
  };

  const handleSend = () => {
    sendMessage(input);
    setInput("");
  };

  const handleStatusUpdate = async () => {
    let tObj = {
      id : ticketData.header_id,
      status : status,
      client_id : ticketData.client_id
    }
    let resStatus = await sendTicketStatusUpdate(tObj)
    if(resStatus){
      
    }
  }

  return (
    <div style={{minHeight:'100vh'}}>
      <div style={{height:'100vh'}}>
      <div class="article-header">
            <div class="d-flex customWrap">
              <div className="dashboardMobileMenu">
                <button className="btn menuBtn" id="menuBtn">
                  <MenuIcon />
                </button>
                <img src={ConceptLogo} width="32" height="32" />
              </div>
              <div class="dhLeft d-flex ">
                  <div class="dhLeftWrap d-flex align-items-center">
                    <h1>Article Tracking</h1>
                  </div>
              </div>
            </div>
            <div className='topFilterWrap'>
              <div className="mobTopHeading">
                <h1>Article Tracking</h1>
              </div>
              <div className='titleRow d-block'>
                <div className='titleLeftWrap'>
                  <div className='filterWrap'>
                    <button 
                      className="prev-button"
                      onClick={() => {setShowList(true)}}
                    >
                      <ArrowLeftIcon color={'#FFFFFF'} /> <label style={{marginLeft:5,marginBottom:0}}> Back </label>
                    </button>
                    
                  </div>
                  <div className='filterWrap'>
                    <a target='_blank' href={ticketData?.article_url} >
                      <button 
                        className="prev-button"
                      ><TicketBackIcon /> View Article
                      </button>
                    </a>
                  </div>
                  <div className='filterWrap'>
                    <label>Heading : {ticketData.heading}</label>
                  </div>
                </div>
                <div className="rightBtnContainer">
                  <ul className="dropDownContainer">
                    {Object.keys(masterUser).length?
                      <div role="group" className="rs-btn-group btn-group" style={{alignItems: "center"}}>
                        <TicketStatusIcon /><label style={{marginLeft:5,marginBottom:0}}>Status Update </label>
                        <ul name="status" class="MEDIA_TYPE Filter show ">
                          <li class="filterOption">
                            <label class="inputWrap">In Progress
                              <input onClick={(e) => {
                                if(e.target.checked){
                                  setStatus(1)
                                }
                              }} type="radio" checked={status == 1} disabled={status == 1} value={1} /><span class="checkmark"></span></label>
                          </li>
                          <li class="filterOption">
                            <label class="inputWrap">Completed
                              <input type="radio" onClick={(e) => {
                                if(e.target.checked){
                                  setStatus(2)
                                }
                              }} checked={status == 2} disabled={status == 2} value={2} /><span class="checkmark"></span></label>
                          </li>
                        </ul>
                        <button onClick={handleStatusUpdate} className="prev-button"><TicketStatusSaveIcon /></button>
                      </div>
                    :""}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        {/* <div className="nav-buttons" >
          {/* Back Button *
          
        </div> */}
        <div className='msg-container' style={{height:'80vh'}}>
          <div style={{height:'90%'}}>
            {isMsgLoading?
              <Loader />:
              messages.map((msg, index) => (
                <div
                  key={index}
                  className={`message-container ${
                    Number(msg.created_by) === Number(userId) ? "user" : "bot"
                  }`}
                >
                  {/* Name Label */}
                  {Number(msg.created_by) !== Number(userId)?
                    <div className="message-label hasTooltip">
                      {msgUserList.find((uData) => Number(uData.userId) == Number(msg.created_by))?.name?.split(" ").map((splitData) => splitData.substr(0,1))}
                      <span className="tooltipWrap center">
                        {msgUserList.find((uData) => Number(uData.userId) == Number(msg.created_by))?.name}
                      </span>
                    </div>
                  :""}

                  {/* Message Text */}
                  <div
                    key={index}
                    className={`message`}
                  >
                    {msg.message}
                  </div>
                  {Number(msg.created_by) === Number(userId)?
                    <div className="message-label hasTooltip">
                      {msgUserList.find((uData) => Number(uData.userId) == Number(msg.created_by))?.name?.split(" ").map((splitData) => splitData.substr(0,1))}
                      <span className="tooltipWrap center">
                        {msgUserList.find((uData) => Number(uData.userId) == Number(msg.created_by))?.name}
                      </span>
                    </div>
                    :""}
                </div>
              ))
            }
          </div>
          <div style={{height:'10%'}} className="chat-input">
            {/* {Object.keys(masterUser).length?
              <div>
                <label>
                  Status Update : 
                  <input type='radio' checked={status == 1} disabled={status == 1} name="statusBtn" value={1} onClick={(e) => {
                      if(e.target.checked){
                        setStatus(1)
                      }
                    }} className='ml-1 mr-1' />In Progress
                  <input type='radio' checked={status == 2} disabled={status == 2} name="statusBtn" value={2} onClick={(e) => {
                    if(e.target.checked){
                      setStatus(2)
                    }
                  }} className='ml-1 mr-1' />Completed
                  <label className='hasTooltip'>
                    <span className="tooltipWrap center">Save</span>
                    <button onClick={handleStatusUpdate}><SendTicketIcon fill={"#ffffff"} /></button>
                  </label>
                </label>
              </div>
              :""} */}
          {status != 2?
            <>
              <ul className="dropDownContainer">
                <div role="group" className="rs-btn-group btn-group" style={{alignItems: "center"}}>
                  <label style={{marginLeft:5,marginBottom:0}}>Notify Master </label>
                  <ul name="status" class="MEDIA_TYPE Filter show ">
                    <li class="filterOption">
                      <input type="checkbox" checked={notifyMaster} onClick={(e) => {
                        if(e.target.checked){
                          setNotifyMaster(1)
                        }
                        else{
                          setNotifyMaster(0)
                        }
                      }} /><span class="checkmark"></span>
                    </li>
                  </ul>
                </div>
              </ul>
              <input
                type="text"
                placeholder="Type a message..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleSend()}
              />
                <div className='hasTooltip'>
                  <span className="tooltipWrap center">Send</span>
                  <button onClick={handleSend}><SendTicketIcon fill={"#ffffff"} /></button>
                </div>
              </>
            :""}
        </div>
      </div>
        
      </div>
    </div>
  );
}

export default Ticket;
